import {
  WorkspaceEnvironment,
  WorkspaceStatus,
} from '@sunstone/api-client/gen/deployments/v1/deployments_pb';

export function workspaceEnvironmentKey(e: WorkspaceEnvironment): string {
  switch (e) {
    case WorkspaceEnvironment.DEVELOPMENT:
      return 'WORKSPACE_ENVIRONMENT_DEVELOPMENT';
    case WorkspaceEnvironment.STAGING:
      return 'WORKSPACE_ENVIRONMENT_STAGING';
    case WorkspaceEnvironment.PRODUCTION:
      return 'WORKSPACE_ENVIRONMENT_PRODUCTION';
    default:
      return 'WORKSPACE_ENVIRONMENT_UNSPECIFIED';
  }
}

export function workspaceEnvironmentFromKey(key: string | null): WorkspaceEnvironment {
  switch (key) {
    case 'WORKSPACE_ENVIRONMENT_DEVELOPMENT':
      return WorkspaceEnvironment.DEVELOPMENT;
    case 'WORKSPACE_ENVIRONMENT_STAGING':
      return WorkspaceEnvironment.STAGING;
    case 'WORKSPACE_ENVIRONMENT_PRODUCTION':
      return WorkspaceEnvironment.PRODUCTION;
    default:
      return WorkspaceEnvironment.UNSPECIFIED;
  }
}

export function workspaceStatusKey(s: WorkspaceStatus): string {
  switch (s) {
    case WorkspaceStatus.PROVISIONING:
      return 'WORKSPACE_STATUS_PROVISIONING';
    case WorkspaceStatus.HEALTHY:
      return 'WORKSPACE_STATUS_HEALTHY';
    case WorkspaceStatus.DEGRADED:
      return 'WORKSPACE_STATUS_DEGRADED';
    case WorkspaceStatus.UNAVAILABLE:
      return 'WORKSPACE_STATUS_UNAVAILABLE';
    case WorkspaceStatus.BLOCKED:
      return 'WORKSPACE_STATUS_BLOCKED';
    case WorkspaceStatus.INACTIVE:
      return 'WORKSPACE_STATUS_INACTIVE';
    case WorkspaceStatus.DEPROVISIONING:
      return 'WORKSPACE_STATUS_DEPROVISIONING';
    case WorkspaceStatus.PENDING_DEPLOYMENT:
      return 'WORKSPACE_STATUS_PENDING_DEPLOYMENT';
    case WorkspaceStatus.PROVISIONING_FAILED:
      return 'WORKSPACE_STATUS_PROVISIONING_FAILED';
    case WorkspaceStatus.DEPROVISION_FAILED:
      return 'WORKSPACE_STATUS_DEPROVISION_FAILED';
    default:
      return 'WORKSPACE_STATUS_UNSPECIFIED';
  }
}

export function workspaceStatusFromKey(key: string | null): WorkspaceStatus {
  switch (key) {
    case 'WORKSPACE_STATUS_PROVISIONING':
      return WorkspaceStatus.PROVISIONING;
    case 'WORKSPACE_STATUS_HEALTHY':
      return WorkspaceStatus.HEALTHY;
    case 'WORKSPACE_STATUS_DEGRADED':
      return WorkspaceStatus.DEGRADED;
    case 'WORKSPACE_STATUS_UNAVAILABLE':
      return WorkspaceStatus.UNAVAILABLE;
    case 'WORKSPACE_STATUS_BLOCKED':
      return WorkspaceStatus.BLOCKED;
    case 'WORKSPACE_STATUS_INACTIVE':
      return WorkspaceStatus.INACTIVE;
    default:
      return WorkspaceStatus.UNSPECIFIED;
  }
}

export const STATUS_FILTER_OPTIONS = [
  { value: 'WORKSPACE_STATUS_HEALTHY', label: 'Healthy' },
  { value: 'WORKSPACE_STATUS_PROVISIONING', label: 'Provisioning' },
  { value: 'WORKSPACE_STATUS_DEGRADED', label: 'Degraded' },
  { value: 'WORKSPACE_STATUS_UNAVAILABLE', label: 'Unavailable' },
  { value: 'WORKSPACE_STATUS_BLOCKED', label: 'Blocked' },
  { value: 'WORKSPACE_STATUS_INACTIVE', label: 'Inactive' },
];

export const ENV_LABELS: Record<string, string> = {
  WORKSPACE_ENVIRONMENT_DEVELOPMENT: 'Dev',
  WORKSPACE_ENVIRONMENT_STAGING: 'Stage',
  WORKSPACE_ENVIRONMENT_PRODUCTION: 'Prod',
};

/** Valid environment condition values for access rules — the exact enum-name
 * strings the backend matches against (see workspaceEnvironmentKey), not the
 * short display labels. */
export const WORKSPACE_ENVIRONMENT_OPTIONS: { value: string; label: string }[] = [
  WorkspaceEnvironment.DEVELOPMENT,
  WorkspaceEnvironment.STAGING,
  WorkspaceEnvironment.PRODUCTION,
].map((e) => {
  const key = workspaceEnvironmentKey(e);
  return { value: key, label: ENV_LABELS[key] ?? key };
});
